import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessGoalsRoute extends Route {
  @service store;

  model() {
    return this.store.findAll('goal', { include: 'target' });
  }
}

export default instrumentRoutePerformance(BusinessGoalsRoute);
